import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { beam } from '@styles/colors/themes';
import styled from 'styled-components';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px 24px 24px 24px;
  width: 100%;
  max-width: 967px;
  height: 100%;
  max-height: 700px;
  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 12px 28px rgba(33, 39, 73, 0.2);
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  grid-template-columns: minmax(min-content, 500px) 1fr;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 18px;
  font-weight: 600;
  flex: 1;
`;

export const Close = styled.div`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  padding-top: 6px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const BackIcon = styled.img`
  cursor: pointer;
`;

export const Label = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 6px;
  padding: 0 4px;
  align-items: center;
`;

export const Line = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  align-self: flex-end;
  margin-top: 24px;
`;

interface IConfirm {
  display?: string;
}

export const Confirm = styled.button<IConfirm>`
  height: 42px;
  padding: 0 16px;
  color: ${({ disabled }) => (disabled ? '#C1C4D6' : '#fff')};
  background-color: ${({ disabled }) => (disabled ? '#EDEFF4' : '#1371fe')};
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;

  &.return {
    background: #fff;
    color: #474d66;
    display: ${({ display }) => display};

    transition: 0.2s;
    :hover {
      background-color: #f6f8ff;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;

  &.pictureInputs {
    width: 100%;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IInput {
  isError?: boolean;
  isLink?: boolean;
}

export const Input = styled.input<IInput>`
  display: flex;
  width: 331px;
  height: 36px;
  border: 1px solid
    ${({ isError }) => (isError ? beam.border.error : '#d8dae5')};
  border-radius: 8px;
  padding: 10px 12px 10px 12px;
  font-size: 12px;

  color: ${({ isLink }) => (isLink ? beam.color.primaryBlue : '#474d66')};
  text-decoration-line: ${({ isLink }) => (isLink ? 'underline' : 'unset')};

  transition: all 0.2s;

  margin-top: 8px;

  ::placeholder {
    color: #8f95b2;
  }
  &.infoInputs {
    width: 100%;
  }
`;
export const SelectFile = styled.label`
  display: flex;
  width: 90px;
  height: 36px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  color: #696f8c;
  background: #fff;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  box-sizing: border-box;

  margin-left: -90px;

  ::-webkit-file-upload-button {
    display: none;
  }

  transition: 0.2s;
  :hover {
    filter: brightness(0.9);
  }
`;

export const FileName = styled.div`
  width: 300px;
  height: 36px;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  color: #474d66;
  background: #fff;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 12px;
  border: 1px solid #d8dae5;
`;

export const IconCloseAwesome = styled(FontAwesomeIcon)`
  position: absolute;
  background: white;
  width: 24px !important;
  padding: 1px 6px;
  right: 0px;
  cursor: pointer;
`;

export const ProfileImg = styled.img`
  width: 62px;
  height: 62px;
  border-radius: 32px;

  margin-right: 24px;
  object-fit: cover;
`;

export const Form = styled.form`
  width: 100%;
`;

export const Divider = styled.div`
  height: 24px;
`;

export const SpacingDivider = styled.div`
  width: 16px;
`;

export const Description = styled.div`
  font-weight: 400;
  color: #474d66;
  font-size: 14px;
  margin-bottom: 24px;
`;

export const Error = styled.div`
  color: #ea1212;
  font-size: 12px;
  font-weight: 400;
  margin-top: 16px;
  margin-bottom: 24px;
`;

export const Icon = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  color: #474d66;
`;

interface IBody {
  show: boolean;
}

export const Body = styled.div<IBody>`
  display: ${({ show }) => (show ? 'block' : 'none')};

  background: #fff;
  width: 100%;
  height: 100%;
  max-height: 390px;

  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const TabsContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
`;

export const Tabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
`;

interface isActiveProps {
  isActive?: boolean;
  isDisabled?: boolean;
}

export const Indicator = styled.div<isActiveProps>`
  height: 2px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: ${({ isActive }) => (isActive ? '#1371fe' : 'transparent')};
  z-index: 2;
`;

export const Back = styled.div`
  height: 1px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: #edeff4;
  z-index: 1;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  & + & {
    margin-left: 48px;
  }
`;

export const LabelText = styled.div<isActiveProps>`
  white-space: nowrap;
  font-weight: ${({ isActive }) => (isActive ? '500' : '400')};
  font-size: 14px;
  color: ${({ isActive }) => (isActive ? '#1B203A' : '#8f95b2')};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.3' : 'unset')};

  &.help {
    font-size: 14px;
    font-weight: 500;
    color: #474d66;
    margin-left: 8px;
  }
`;

interface IHelpToolTipDiv {
  display?: boolean;
}

export const HelpToolTipDiv = styled.div<IHelpToolTipDiv>`
  display: ${({ display }) => (display ? 'flex' : 'none')};
  padding: 10px 16px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const HelpToolTipTextDiv = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 500;
`;

export const HelpToolTipIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const HelpToolTipIconContainer = styled.div`
  width: 16px;
  height: 20px;
`;

export const Preview = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Heading = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 4fr 1fr 2fr 2fr 1fr;
  grid-row-gap: 0;
`;

export const PreviewRow = styled.div`
  width: 100%;
  height: 42px;
  display: grid;
  grid-template-columns: 1fr 4fr 1fr 2fr 2fr 1fr;
  grid-row-gap: 0;
  background-color: #f5f7fb;
  border-radius: 8px;
  padding-left: 12px;
  gap: 10px;

  align-items: center;
`;

export const Placeholder = styled.div`
  width: 100%;
  height: 10px;
  border-radius: 5px;
  background-color: #d8dae5;
`;

export const Text = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #8f95b2;

  height: 28px;
  padding: 0 12px 10px 12px;
`;

export const HolderDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8.75px;
  align-items: center;
  justify-content: center;
`;

export const Internal = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1371fe;
`;

export const Tags = styled.div`
  display: flex;
  padding: 4px 12px 4px 12px;
  border-radius: 15px;
  height: 30px;
  background-color: #edeff4;
  font-size: 14px;
  font-weight: 500;
  color: #474d66;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
  gap: 8px;
`;

interface ISpan {
  display: string;
}

export const Span = styled.div<ISpan>`
  display: ${({ display }) => display};
  width: 18px;
  height: 18px;
  margin-left: 9.56px;
`;

export const GhostDiv = styled.div`
  display: none;
`;

export const LoadingFilter = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  background: #fff;
  width: 100%;
  height: 100%;
  z-index: 1;
  border-radius: 8px;
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
`;
